import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound(): JSX.Element {
  return (
    <main className="min-h-screen flex items-center justify-center bg-bg px-6">
      {/* proto .stub empty state */}
      <div className="flex flex-col items-center justify-center text-center text-dim p-[70px_20px] border border-dashed border-border rounded-[14px] bg-surface max-w-md w-full">
        <Compass className="w-[34px] h-[34px] text-dim mb-3" aria-hidden />
        <h1 className="font-display font-semibold text-[18px] text-text mb-[5px]">
          Page not found
        </h1>
        <p className="text-[13px] max-w-[420px] mb-5">
          The route you tried doesn&apos;t exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 h-[34px] px-3 rounded-lg text-[12.5px] font-semibold border border-transparent bg-accent text-white hover:bg-[#4338ca] min-h-[44px] sm:min-h-[34px] no-underline"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
